import type {
  ILocationRepository,
  ProjectLocationTabOptions,
  ProjectLocationTabSegmentCounts,
} from '../repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

type Options = Omit<ProjectLocationTabOptions, 'segment' | 'limit' | 'offset'>;

export function createCountProjectLocationTabSegmentsUseCase({ locationRepository }: Deps) {
  return async function countProjectLocationTabSegments(
    options: Options,
  ): Promise<ProjectLocationTabSegmentCounts> {
    return locationRepository.countProjectLocationTabSegments(options);
  };
}
